import {
  Button,
  Card,
  DatePicker,
  Form,
  Input,
  Select,
  Typography,
} from "antd";
import dayjs from "dayjs";
import { Gift } from "lucide-react";
import React, { useEffect } from "react";

const { Paragraph } = Typography;
const { Option } = Select;

const BasicInfoForm = ({
  form,
  onContinue,
  formValues,
  onChangeFormValues,
}) => {
  // Sync form fields whenever formValues changes
  useEffect(() => {
    form.setFieldsValue({
      ...formValues,
      dob: formValues.dob ? dayjs(formValues.dob) : null,
    });
  }, [formValues, form]);

  const handleSubmit = (values) => {
    const formattedValues = {
      ...values,
      dob: values.dob ? dayjs(values.dob).format("YYYY-MM-DD") : undefined,
    };
    onContinue(formattedValues);
  };

  return (
    <Card
      title="Basic Information"
      style={{
        marginTop: 32,
        width: "100%",
        maxWidth: 400,
        maxHeight: "80vh", // Restrict height
        overflowY: "auto", // Enable vertical scrolling
      }}
    >
      <Paragraph className="text-center text-muted">
        Tell us a bit about yourself (Tier 1 KYC)
      </Paragraph>

      <Form layout="vertical" form={form} onFinish={handleSubmit}>
        <Form.Item
          name="name"
          label="Full Name"
          rules={[{ required: true, message: "Please enter your full name" }]}
        >
          <Input
            placeholder="Enter your full name"
            value={formValues.name}
            onChange={(e) => onChangeFormValues("name", e.target.value)}
          />
        </Form.Item>

        {/* New Email Field */}
        <Form.Item
          name="email"
          label="Email Address"
          rules={[
            { required: true, message: "Please enter your email address" },
            { type: "email", message: "Please enter a valid email address" },
          ]}
        >
          <Input
            placeholder="Enter your email"
            value={formValues.email}
            onChange={(e) => onChangeFormValues("email", e.target.value)}
          />
        </Form.Item>

        <Form.Item
          name="dob"
          label="Date of Birth"
          rules={[
            { required: true, message: "Please select your date of birth" },
          ]}
        >
          <DatePicker
            style={{ width: "100%" }}
            format="DD-MM-YYYY"
            disabledDate={(current) =>
              current && current > dayjs().endOf("day")
            }
            value={formValues.dob}
            onChange={(date) => onChangeFormValues("dob", date)}
          />
        </Form.Item>

        <Form.Item
          name="gender"
          label="Gender"
          rules={[{ required: true, message: "Please select your gender" }]}
        >
          <Select
            placeholder="Select your gender"
            value={formValues.gender}
            onChange={(value) => onChangeFormValues("gender", value)}
          >
            <Option value="Male">Male</Option>
            <Option value="Female">Female</Option>
            <Option value="Others">Others</Option>
          </Select>
        </Form.Item>

        <Form.Item
          name="nationality"
          label="Nationality"
          rules={[
            { required: true, message: "Please select your nationality" },
          ]}
        >
          <Select
            placeholder="Select your nationality"
            value={formValues.nationality}
            onChange={(value) => onChangeFormValues("nationality", value)}
          >
            <Option value="Indian">Indian</Option>
            <Option value="American">American</Option>
            <Option value="Canadian">Canadian</Option>
          </Select>
        </Form.Item>

        <Form.Item
          name="refferalCode"
          label={
            <span>
              <Gift size={14} color="green" style={{ marginRight: 6 }} />
              Referral Code (Optional)
            </span>
          }
        >
          <Input
            placeholder="Enter referral code"
            value={formValues.refferalCode}
            onChange={(e) => onChangeFormValues("refferalCode", e.target.value)}
          />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            size="large"
            block
            style={{
              backgroundColor: "#1d4ed8",
              borderColor: "#1d4ed8",
            }}
            htmlType="submit"
          >
            Continue
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default BasicInfoForm;
